export default __webpack_public_path__ + "static/media/report-icon.0ddb4d57.svg";